import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";

import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { obtenerCategoriasAct } from "../../../../../Base/API/Global/Categorias/CategoriasRequests";
import { obtenerUnitsAct } from "../../../../../Base/API/Global/UnidadesMedida/UnitRequests";
import { toastShow } from "../../../../../Base/Services/ToastService";

import { EliminarDetalleProductos, getDetalleProductos, GuardarDetalleProductos } from "../../../../../API/Global/ActivosFijos/DetalleProductosRequest";

import ProductosOverlayPanel from "../../../Compras/Requisas/CrudRequisa/OverlayPanels/ProductoOverlayPanel";


const DetalleProductosScreen = ({ activeIndex, selected, setDetProductosList }) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const [selectedDetalles, setSelectedDetalles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [detallesData, setDetallesData] = useState([]);
  const [idCategoria, setIdCategoria] = useState(null);
  const [unidadMedida, setUnidadMedida] = useState([{}]);

  const getInfo = async () => {
    setLoading(true);
  
    const detalleP = await getDetalleProductos();
    let IdActivoPadre = selected?.IdActivoPadre
    let IdActivo = selected?.IdActivo
    const filterDetalle = detalleP.filter((item) => item.IdActivo === IdActivoPadre || item?.IdActivo === IdActivo);

    setDetProductosList(filterDetalle);
  
    const suministros = filterDetalle.filter((item) => item.IdCategoria === 2);
    const repuestos = filterDetalle.filter((item) => item.IdCategoria === 1);
  
    const categories = await obtenerCategoriasAct();
    const unitMedida = await obtenerUnitsAct();
    setUnidadMedida(unitMedida);
    let filterIdCa;
  
    if (activeIndex === 2) {
      setDetallesData(suministros);
      filterIdCa = categories.filter((i) => i.IdCategoria === 2);
      setIdCategoria(filterIdCa?.[0]?.IdCategoria);
    } else if (activeIndex === 3) {
      setDetallesData(repuestos);
      filterIdCa = categories.filter((i) => i.IdCategoria === 1);
      setIdCategoria(filterIdCa?.[0]?.IdCategoria);
    }
  
    setLoading(false);
  };
  
  const changeVidaUtil = ({ data }) => {
    return (
      <div>
        <Dropdown
          value={data?.IdUnitVidaUtil}
          options={unidadMedida}
          style={{ width: "100%", position: "relative" }}
          optionLabel="UnitName"
          optionValue="IdUnit"
          filter
          filterBy="UnitName"
          clearIcon="pi pi-times"
          onChange={(e) => {
            if (selectedDetalles?.length > 1) {
              let tempo2 = [...selectedDetalles];
  
              selectedDetalles.forEach((item) => {
                const index = tempo2.findIndex(
                  (detail) => detail.IdDetalleProducto === item.IdDetalleProducto
                );
                if (index !== -1) {
                  tempo2[index] = {
                    ...tempo2[index],
                    IdUnitVidaUtil: e.value,
                    UnitName: unidadMedida.find((unit) => unit.IdUnit === e.value)?.UnitName || "",
                  };
                }
              });
  
              setDetallesData(tempo2);
              setSelectedDetalles([]);
            } else {
              setDetallesData((prevData) => {
                const newData = [...prevData];
                const index = newData.findIndex(
                  (item) => item.IdDetalleProducto === data.IdDetalleProducto
                );
                if (index !== -1) {
                  newData[index] = {
                    ...newData[index],
                    IdUnitVidaUtil: e.value,
                    UnitName: unidadMedida.find((unit) => unit.IdUnit === e.value)?.UnitName || "",
                  };
                }
                return newData;
              });
            }
          }}
        />
      </div>
    );
  };

  //overlay productos
  const changeProducto = ({ data }) => {
    return (
      <ProductosOverlayPanel
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const productoExistente = detallesData.some((detalle) => detalle.IdProducto === data?.IdProduct);

          if (productoExistente) {
            toastShow(toast, "warn", "Advertencia", "No se permiten productos duplicados.");
            api.stopEditing();
            return;
          }

          const index = detallesData.findIndex((detail) => detail.IdDetalleProducto === rowData.IdDetalleProducto);
          let newDetail = [...detallesData];
          newDetail[index].IdProducto = data?.IdProduct;
          newDetail[index].CodigoProducto = data?.CodigoProducto;
          newDetail[index].NombreProducto = data?.NombreProducto;
          newDetail[index].IdUnitVidaUtil = data?.IdUnitVidaUtil;
          newDetail[index].UnitName = data?.UnitNameVU;
          newDetail[index].VidaUtil = data?.VidaUtil;
          setDetallesData(newDetail);
          api.stopEditing();
        }}
        IdCategoria={activeIndex === 2 ? 2 : 1}
      />
    );
  };
  
  //Tabla
  const columns = [
    {
      field: "IdDetalleProducto",
      header: "ID",
      headerEn: "ID",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.IdDetalleProducto,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "Xsmall",
      Format: "Estado",
      filter: false,
      frozen: true,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "CodigoProducto",
      header: "Código",
      headerEn: "Code",
      frozen: true,
      Sumary: "count",
      className: "Xsmall",
      editable: true,
      cellEditor: changeProducto,
    },
    {
      header: "Producto",
      headerEn: "Product",
      field: "NombreProducto",
      className: "XXlarge",
    },
    {
      header: "Unidad Vida Util",
      headerEn: "Unit Useful Life",
      field: "UnitName",
      editable: true,
      className: "small",
      cellEditor: changeVidaUtil,
    },
    {
      header: "Vida Util",
      headerEn: "Useful life",
      field: "VidaUtil",
      editable: true,
      className: "small",
    },
    {
      header: "Catidad Requerida",
      headerEn: "Required Quantity",
      field: "CantidadRequerida",
      editable: true,
      className: "small",
    },
    {
      header: "Comentario",
      headerEn: "Comment",
      field: "Comentario",
      editable: true,
      className: "XXXlarge",
    },
  ];

  const table = {
    Columns: columns,
    Data: detallesData,
    key: "IdDetalleProducto",
    selected: selectedDetalles,
    setSelected: setSelectedDetalles,
  };

  const agregarDet = () => {
    let newRowData = [...detallesData];

    let index = -(detallesData?.length + 1);

    const newData = {
      IdDetalleProducto: index,
      IdEstado: 5,
      StatusName: "Activo",
      IdActivo: selected?.IdActivo,
      IdUnitVidaUtil: null,
      VidaUtil: 0,
      IdCategoria: newRowData[0]?.IdCategoria ?? idCategoria,
      CantidadRequerida: 0,
      IdUserCreate: userAuth?.IdUser,
      IdUserEdit: userAuth?.IdUser
    };

    newRowData.push(newData);
    setDetallesData(newRowData);
  };
  

  const guardarDatos = async () => {
    const tieneProductos = detallesData.some((detalle) => !detalle.IdProducto);
    const VU = detallesData.some((detalle) => detalle.VidaUtil <= 0);
    const CR = detallesData.some((detalle) => detalle.CantidadRequerida <= 0);

    if(tieneProductos){
      toastShow( toast, "warn", "Advertencia", "Todos los detalles deben tener un Producto." );
      return
    }

    // if(VU){
    //   toastShow( toast, "warn", "Advertencia", "Todos los detalles deben tener vida util." );
    //   return
    // }

    if(CR){
      toastShow( toast, "warn", "Advertencia", "Todos los detalles deben tener cantidad requerida." );
      return
    }

    setLoading(true);
    const Datos = detallesData

    const resultado = await GuardarDetalleProductos(Datos);
    if (resultado[0]?.ESTADO === 1) {
      toastShow(
        toast,
        "success",
        "Datos Agregados",
        resultado[0]?.MENSAJE
      );
      getInfo();
      setTimeout(() => {
        setLoading(false);
      }, 1300);
    } else {
      toastShow(
        toast,
        "error",
        "Error",
        resultado[0]?.MENSAJE
      );
    }
    setLoading(false);
  };

  const eliminarDatos = () => {
    let IdPositivos = selectedDetalles.filter((e) => e.IdDetalleProducto > 0);

    if(IdPositivos.length > 0){
      confirmDialog({
        message: `¿Esta seguro de eliminar los detalles seleccionados?`,
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
          setLoading(true);
          const Ids = IdPositivos.map((e) => e.IdDetalleProducto).join(',');
          const eliminar = await EliminarDetalleProductos(Ids);
          toastShow(
            toast,
            "success",
            "Datos Eliminados",
            "Detalles Eliminados correctamente."
          );
          getInfo();
          setLoading(false);
        },
        reject: () => {}
      })
    }

    setDetallesData(prev => prev.filter(e => e.IdDetalleProducto > 0));
    setSelectedDetalles([]);
  };

  useEffect(() => {
    getInfo();
  }, [activeIndex]);

  return (
    <div style={{ height: "48vh" }}>
      <Toast ref={toast}/>
      <Loader loading={loading} />
      <div className="d-flex gap-2 my-2">
        <Button icon="pi pi-refresh" onClick={getInfo} />
        <Button icon="pi pi-plus" onClick={agregarDet} />
        <Button icon="pi pi-save" disabled={detallesData.length <= 0} onClick={guardarDatos} />
        <Button icon="pi pi-times" className="p-button-danger" disabled={selectedDetalles.length <= 0} onClick={eliminarDatos} />
      </div>
      <AgGrid table={table} />
    </div>
  );
};

export default DetalleProductosScreen;
